var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFoodAndDrink = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 20,
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#6467EF",
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.295 19H4.978c-.632 0-1.16-.48-1.222-1.11L2.636 6.319h9l-1.12 11.573c-.06.629-.59 1.109-1.221 1.109z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.955 6.318A3.682 3.682 0 1 1 11.636 10M4.273 6.318 3.455 1.41 1 1M5 9l.818 7.364M11.636 3.864l-.003 1.639M12.455 5.909l1.227-.818M12.045 6.725l.819 1.23M10.818 5.909 9.591 4.682"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFoodAndDrink);
export default ForwardRef;